module.exports = "/images/profile-cover.jpg?f776f63e53744f90d70d3931947d963a";